// extracted by mini-css-extract-plugin
export default {"words":"editConceptPopup_words__rucN-","wordsTitle":"editConceptPopup_wordsTitle__Ob980"};